import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect, useCallback } from 'react'
import { createPortal } from 'react-dom'


// iframe for displaying interactives' preview. Allows interactive to
// display with appropriate responsive styles.
export const Frame = React.memo(({ children,hasStyles,initFunction,name, ...props }) => {

  const useStyles = makeStyles(theme => ({
    root: {
      paddingTop: props.topPadding ? 30 : 0,
      border:"none",
      width:"100%",
      background: '#fff',
    }
  }))

  const classes = useStyles();

  const [contentRef, setContentRef] = useState(null);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [hideContent, setHideContent] = useState(true);

  const mountNode = contentRef ? contentRef.contentWindow.document.body  : null;  


  const runInitFunction = useCallback(() => {
    if (!contentRef) {
      return;
    }

    const $ = contentRef.contentWindow.$
    
    if (!$ || !initFunction || !contentRef.contentWindow[initFunction]) {
      return;
    }

    contentRef.contentWindow[initFunction]()

    return 
  }, [contentRef,initFunction])



  // Run "init" function in interactive JS
  // whenever refresh counter is updated
  useEffect(() => {
    runInitFunction()
  }, [runInitFunction,refreshCounter])


  // Update refresh counter to force iframe contents 
  // to rerender
  const updateRefreshCounter = () => {
    contentRef.contentWindow.activeScreen = 1;
    setRefreshCounter(refreshCounter + 1);
  }


  // Listen for "refreshFrame" event (i.e. from clicking refresh button
  // in Speeddial to trigger refresh of iframe contents
  useEffect(() => {
    window.addEventListener('refreshFrame', updateRefreshCounter)
    return () => window.removeEventListener('refreshFrame', updateRefreshCounter)
  })


  // Detect when scripts are loaded to call interactive's "init" function.
  // Also display interactive at this time.
  // @todo: loading spinner until shown. Error if load fails.
  const handleScriptLoad = useCallback(() => {
    const $ = contentRef.contentWindow.$
    if ($ && contentRef.contentWindow[initFunction]) {
      setHideContent(false)
      runInitFunction();
    }
  }, [contentRef,initFunction,runInitFunction])


  // Add scripts after iframe (and body) has loaded. 
  // @todo: can this go alongside where the head and doctype is set?
  // Would need to add the 'onload' functions differently.
  const onIframeLoad = useCallback(() => {

    const frameDoc = contentRef.contentWindow.document;

    frameDoc.onreadystatechange = function () {
      // Prevent from running twice
      if (!frameDoc.body.classList.contains('script-added')) {
        // Create interactive script
        const scriptEl = document.createElement('script');
        scriptEl.src = `/js/${name}.js`;
        scriptEl.onload = handleScriptLoad;

        // Attach script
        frameDoc.body.appendChild(scriptEl);

        // Prevent from running twice
        frameDoc.body.classList.add('script-added');

      }

    }
  }, [contentRef,name,handleScriptLoad])




  
  // detect when iframe has loaded
  // iframe.load event doesn't work in Safari when iframe has no src
  useEffect(() => {
    if (!contentRef) {
      return;
    } 
    
    var _timer = setInterval(function() {
      let doc = contentRef.contentDocument || contentRef.contentWindow;
      if (doc && doc.document) doc = doc.document;
      if (doc && doc.readyState === 'complete') {
        clearInterval(_timer);
        
        // Set doctype and head
        doc.open('text/html', 'replace');
        doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="utf-8" />
            <title>Preview</title>
            <meta name="viewport" content="width=device-width, initial-scale=1" />

            <link href="//fonts.googleapis.com/css?family=Poppins:400,400i,500,500i,600,600i,700,700i|Teko:600,700&display=swap" rel="stylesheet" />
            <link rel="stylesheet" href="//stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css" integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T" crossorigin="anonymous" />
            <link rel="stylesheet" href="/css/style.css" media="all" />
            <link rel="stylesheet" href="/css/intv-styles.min.css" media="all" />
            ${ hasStyles ? `<link rel="stylesheet" href="/css/intv-themes/${name}.css" />` : '' }

            <script src="//code.jquery.com/jquery-3.2.1.min.js" integrity="sha256-hwg4gsxgFZhOsEEamdOYGBf13FyQuiTwlAQgxVSNgt4=" crossorigin="anonymous"></script>
            <script src="//stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js" integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM" crossorigin="anonymous"></script>

          </head>
          <body class="dinfos-body">
           
          </body>
        </html>`);

        doc.close();

        onIframeLoad();
      }
    }, 100);
      
  }, [contentRef,hasStyles,name,onIframeLoad])




  return (
    <iframe ref={setContentRef} title="Preview" className={classes.root}>
      <div key={refreshCounter}>
        {mountNode && !hideContent &&
          createPortal(
            React.cloneElement(React.Children.only(children),{runInitFunction,window:contentRef.contentWindow}),
            mountNode, 
          )
        }
      </div>
    </iframe>
  )
})